import { APIMethods, apiProxy, TResponse } from 'utils/api/apiRequestProxy';
import { MultiAccountAutoLogin } from './types';

export async function fetchMultiAccountAutoLogin(): Promise<TResponse<MultiAccountAutoLogin[]>> {
    return apiProxy<MultiAccountAutoLogin[]>({
        url: '/multi-account/auto-login',
        method: APIMethods.GET,
    });
}
